module.exports = __webpack_public_path__ + "assets/stethoscope.2b719478.svg";